// pages/Dashboard.jsx

import React, { Suspense, useEffect } from "react";
import { useDarkMode } from "../context/darkModeContext";
import { Dialog } from "@mui/material";
import useAuth from "../stores/authStore";
import DueDate from "../components/dashboard/DueDate";
import LatestActivities from "../components/dashboard/LatestActivities";
import MailWidget from "../components/dashboard/MailWidget";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { useDashboardStore } from "../stores/dashboardStore";
import { LoadingSection } from "../utils/loading";
import EditDashboardModal from "../components/dashboard/EditDashboardModal";
import AnnouncementsWidget from "../components/dashboard/widgets/AnnouncementsWidget";
import CalendarWidget from "../components/dashboard/widgets/CalendarWidget";
import EmployeeStatisticsWidget from "../components/dashboard/widgets/EmployeeStatisticsWidget";
import UpcomingEventsWidget from "../components/dashboard/widgets/UpcomingEventsWidget";
import TodoWidget from "../components/dashboard/widgets/TodoWidget";

// V2: re-enable folder section when folder support launches
// const DashboardFoldersSection = React.lazy(
//   () => import("../components/dashboard/DashboardFoldersSection")
// );

const DashboardFilesSection = React.lazy(
  () => import("../components/dashboard/DashboardFilesSection")
);

const FileViewer = React.lazy(
  () => import("../components/filesviewpage/FileViewer")
);

const DashboardPage = () => {
  const { darkMode } = useDarkMode();
  const isFileViewerOpen = useAuth((state) => state.isFileViewerOpen);
  const closeFileViewer = useAuth((state) => state.closeFileViewer);
  const profileData = useAuth((state) => state.profileData);
  const { pinnedWidgets, toggleEditModal, loadPreferences } =
    useDashboardStore();

  useEffect(() => {
    if (profileData && profileData.dashboard_widgets) {
      loadPreferences(profileData.dashboard_widgets);
    }
  }, [profileData?.dashboard_widgets]);

  const renderWidget = (id) => {
    switch (id) {
      case "dueDate":
        return <DueDate key={id} />;
      case "mailBox":
        return <MailWidget key={id} />;
      case "latestActivity":
        return <LatestActivities key={id} />;
      case "notifications":
      case "announcements":
        return <AnnouncementsWidget key={id} />;
      case "calendar":
        return <CalendarWidget key={id} />;
      case "departmentTaskPulse":
      case "employeeStats":
        return <EmployeeStatisticsWidget key={id} />;
      case "upcomingEvents":
        return <UpcomingEventsWidget key={id} />;
      case "todo":
        return <TodoWidget key={id} />;
      case "accessRequest":
        return (
          <div
            key={id}
            className="bg-white rounded-xl shadow-sm border p-4 flex items-center justify-center h-40 text-gray-400 font-medium border-dashed"
          >
            Access Request and Block (Coming Soon)
          </div>
        );
      case "storageByDept":
        return (
          <div
            key={id}
            className="bg-white rounded-xl shadow-sm border p-4 flex items-center justify-center h-40 text-gray-400 font-medium border-dashed"
          >
            Storage by Department (Coming Soon)
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`w-full p-4 h-full overflow-y-auto ${
        darkMode ? "bg-gray-800 text-white" : "text-gray-800"
      }`}
    >
      <Link
        to="/chat"
        className="fixed bottom-5 right-5 z-10 h-16 w-16 bg-[#4A3AFF] rounded-full flex items-center justify-center "
      >
        <ChatBubbleOutlineOutlinedIcon className="text-white" />
      </Link>
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={toggleEditModal}
          className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 rounded-lg font-medium shadow-sm border border-indigo-100 hover:bg-indigo-50 transition-colors"
        >
          <EditIcon fontSize="small" /> Edit
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {pinnedWidgets.map((w) => renderWidget(w.id))}
      </div>
      {/* <div className="flex flex-col md:flex-row gap-4">
        <DueDate />
        <div className="w-full flex flex-col gap-4">
          <LatestActivities />
          <MailWidget />
        </div>
      </div> */}
      <div>
        {/* V2: re-enable folder section when folder support launches */}
        {/* <Suspense fallback={<LoadingSection height={240} />}>
          <DashboardFoldersSection />
        </Suspense> */}
       
        <Suspense fallback={<LoadingSection height={560} />}>
          <DashboardFilesSection />
        </Suspense>
      </div>
      {/* <div className={`${screenshotDetected ? "blur" : ""}`}> */}
      <Dialog
        open={isFileViewerOpen}
        onClose={closeFileViewer}
        maxWidth="lg"
        PaperProps={{ tabIndex: -1 }}
        TransitionProps={{
          onEntered: () => {
            // ensure focus is inside the dialog, not on a hidden ancestor
            const dialog = document.querySelector('[role="dialog"]');
            if (dialog && typeof dialog.focus === "function") dialog.focus();
          },
        }}
      >
        <Suspense fallback={<LoadingSection />}>
          <FileViewer onClose={closeFileViewer} />
        </Suspense>
      </Dialog>

      <EditDashboardModal />

      {/* </div> */}
    </div>
  );
};

export default DashboardPage;
